import React, { useRef, useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import FileManagerCard from './FileManagerCard';
import StorageUsageCard from './StorageUsageCard';

const FileExplorerPage: React.FC = () => {
  // "Open in file manager" from the usage card: point the manager at the
  // folder and scroll it into view. Nonce so repeat clicks still fire.
  const [fmJump, setFmJump] = useState<{ path: string; nonce: number } | null>(null);
  const fmRef = useRef<HTMLDivElement>(null);

  const openInManager = (path: string) => {
    setFmJump({ path, nonce: Date.now() });
    fmRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <PageTitle breadcrumbs={[]}>File Explorer</PageTitle>
      <div className='container-fluid'>
        <StorageUsageCard onOpenFolder={openInManager} />
        <div ref={fmRef}>
          <FileManagerCard jumpTo={fmJump} />
        </div>
      </div>
    </>
  );
};

export default FileExplorerPage;
